module.exports = __webpack_public_path__ + "static/earth-23087c04f851a9fd4292eb26d7f62205.png";